<script setup>
import { usePage } from "@inertiajs/vue3";
import { computed } from "vue";

const page = usePage();
const backgroundStyle = computed(() => ({
    backgroundImage: `url(${JSON.stringify(page.props.websiteImages?.login || "/img/foto 1.jpg")})`,
}));
</script>

<template>
    <div
        :style="backgroundStyle"
        class="inset-0 fixed left-0 right-0 h-screen w-screen bg-cover bg-theme-primary flex flex-col items-center justify-center"
    >
        <slot></slot>
    </div>
</template>

<style scoped></style>
